import React, {useEffect} from 'react'
import Modal from '../../../../../../libs/_fri/components/CustomModal/CustomModal'
import {useCancelBatchMutation} from '../../../../../../redux/api/services/batch'
import {useListView} from '../../core/ListViewProvider'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../../../redux/store'
import {CustomErrorAlert} from '../../../../../../libs/_fri/components/CustomErrorAlert/CustomErrorAlert'

export const BatchCancelModal = () => {
  const [cancelBatch, {isSuccess, isError, error, reset}] = useCancelBatchMutation()
  const {batchForCancel, setBatchForCancel} = useListView()
  const infoState = useSelector((state: RootState) => state.info)

  useEffect(() => {
    if (!isSuccess) return

    setBatchForCancel(undefined)
  }, [isSuccess])

  return (
    <Modal
      handleClose={() => {
        setBatchForCancel(undefined)
      }}
      handleConfirm={() => {
        if (!batchForCancel) return

        const requestData = {
          info: infoState,
          requestContent: {
            batchId: batchForCancel.id,
          },
        }
        cancelBatch(requestData)
      }}
      variant='danger'
      size='md'
    >
      <div className='d-flex flex-column text-center'>
        <CustomErrorAlert show={isError} error={error} close={reset} />
        <span className='fs-2x text-primary-dark fw-semibold'>Eliminar pago</span>
        <span className='text-gray fs-2'>
          ¿Estás seguro de que deseas eliminar el pago {batchForCancel?.title}?
        </span>
      </div>
    </Modal>
  )
}
